// Vendors
import { COBRANDED_LIGHT_REGULAR_STYLES } from '@openbank/ziniaweb-ui-components';
import styled from 'styled-components';

const HeaderLayoutHeaderComponentStyled = styled.div`
  position: sticky;
  max-height: ${({ theme }) => theme.spacing_500};
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;

  ${COBRANDED_LIGHT_REGULAR_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    flex: 0 0 auto;
  }
`;
HeaderLayoutHeaderComponentStyled.displayName = 'HeaderLayoutHeaderComponentStyled';

const HeaderLayoutContentComponentStyled = styled.div`
  display: flex;
  justify-content: center;
  min-height: calc(100vh - ${({ theme }) => theme.spacing_500});
  width: 100%;
`;
HeaderLayoutContentComponentStyled.displayName = 'HeaderLayoutContentComponentStyled';

export { HeaderLayoutHeaderComponentStyled, HeaderLayoutContentComponentStyled };
